import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'value-added-programme-staff',
  templateUrl: './component.html',
  styleUrls: ['./component.css']
})
export class ValueAddedProgramStaffComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
